module.exports = __webpack_public_path__ + "img/camera-video-off.15c53a73.svg";